function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import LayerGroup from './LayerGroup';
import './LayerSwitch.css';

var mapIcon = React.createElement(
  'svg',
  { viewBox: '0 0 32 32' },
  React.createElement('path', { d: 'M0 6l10-4v24l-10 4z' }),
  React.createElement('path', { d: 'M12 1l10 6v23l-10-5z' }),
  React.createElement('path', { d: 'M24 7l8-6v24l-8 6z' })
);

/**
 * An optional layer switcher.
 * Presents a button on the map, and the user can click it to expand a list of layers.
 * The list will be populated with all of its children (LayerGroups, DrawLayers, VectorLayers and WmsLayers) that have the name-property set.
 * There are default svg-icons in use, but they can be overridden by sending them in as props (icon)
 */

var LayerSwitch = function (_React$Component) {
  _inherits(LayerSwitch, _React$Component);

  function LayerSwitch(props) {
    _classCallCheck(this, LayerSwitch);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.showList = _this.showList.bind(_this);

    _this.state = {
      showList: false
    };
    return _this;
  }

  LayerSwitch.prototype.showList = function showList(e) {
    this.setState({ showList: !this.state.showList });
  };

  LayerSwitch.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        icon = _props.icon,
        name = _props.name,
        tooltip = _props.tooltip;
    var showList = this.state.showList;

    var mainIcon = icon || mapIcon;
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'layer-switch--button-container' },
        React.createElement(
          'button',
          {
            className: 'layer-switch--button',
            onClick: this.showList,
            title: tooltip
          },
          mainIcon
        )
      ),
      React.createElement(
        'div',
        {
          className: 'layer-switch--container' + (!showList ? ' hidden' : '')
        },
        React.createElement(
          LayerGroup,
          { name: name },
          children
        )
      )
    );
  };

  return LayerSwitch;
}(React.Component);

LayerSwitch.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The children of the LayerSwitch.
   */
  children: PropTypes.node,
  /**
   * Button icon, if not set will use default one
   */
  icon: PropTypes.element,
  /**
   * Name
   */
  name: PropTypes.string,
  /**
   * The tooltip to be shown on hover.
   */
  tooltip: PropTypes.string
} : {};

export default LayerSwitch;